<div left-center-container class="flex min-h-full w-full py-12">
  <div class="flex-1 flex flex-col justify-center items-center min-h-full">
    <router-outlet>
    </router-outlet>
  </div>
  <div class="flex-1 hidden lg:block"></div>
</div>
